import { slotShouldForwardProp } from "@mui/material/styles/styled";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import HC_exporting from "highcharts/modules/exporting";
import HC_patternFill from "highcharts/modules/pattern-fill";
import { useEffect, useState } from "react";

HC_exporting(Highcharts);
HC_patternFill(Highcharts);

Highcharts.setOptions({
  lang: {
    numericSymbols: null,
    decimalPoint: ".",
    thousandsSep: ",",
  },
});

const testArray = [
  {
    name: "solar",
    type: "area",
    data: [
      { x: 1, y: 5 },
      { x: 2, y: 4 },
      { x: 3, y: 4 },
      { x: 4, y: 6 },
    ],
    stack: "one",
    color: "red",
  },
  {
    name: "wind",
    type: "area",
    data: [
      { x: 1, y: 5 },
      { x: 2, y: 4 },
      { x: 3, y: 4 },
      { x: 4, y: 6 },
    ],
    stack: "one",
  },
  {
    name: "biomass",
    type: "area",
    data: [
      { x: 1, y: -1 },
      { x: 2, y: -2 },
      { x: 3, y: -4 },
      { x: 4, y: -2 },
    ],
    stack: "two",
  },
  {
    name: "demand",
    data: [
      { x: 1, y: 5 },
      { x: 2, y: 4 },
      { x: 3, y: 4 },
      { x: 4, y: 6 },
    ],
    type: "line",
  },
];

const Chart = ({ seriesArray, title, subtitle }) => {
  const [chartOptions, setChartOptions] = useState({
    chart: {
      marginRight: 20,
      marginLeft: 80,
      style: {
        fontFamily: "Source Sans Pro",
      },
      backgroundColor: "#F7F7F7",
    },
    title: {
      text: "",
      align: "left",
      margin: 24,
      style: {
        fontSize: "22px",
        fontWeight: 700,
      },
    },
    subtitle: {
      text: "",
      align: "left",
      style: {
        fontSize: "16px",
        fontWeight: 500,
      },
    },
    series: [],
    xAxis: {
      title: {
        text: undefined,
      },
      lineColor: "#666466",
      lineWidth: 0,
      minPadding: 0.02,
      maxPadding: 0.02,
      tickInterval: 5,
      tickLength: 0,
      labels: {
        style: {
          fontWeight: "600",
          fontSize: "13px",
        },
      },
    },
    yAxis: {
      title: {
        text: undefined,
      },
      gridLineWidth: 0.5,
      gridLineColor: "#BBBBBB",
      tickAmount: 8,
      labels: {
        style: {
          fontWeight: "600",
          fontSize: "13px",
        },
      },
      plotLines: [
        {
          color: "#666466",
          value: 0,
          width: 3,
        },
      ],
    },
    plotOptions: {
      area: {
        stacking: "normal",
        fillOpacity: 0.9,
        lineWidth: 0,
      },
      line: {
        lineWidth: 3,
      },
      series: {
        marker: {
          enabled: false,
          symbol: "circle",
          states: {
            hover: {
              enabled: true,
            },
          },
        },
        dashStyle: "dash",
      },
    },
    credits: {
      enabled: false,
    },
    legend: {
      margin: 10,
      squareSymbol: false,
      symbolHeight: 12,
      symbolRadius: 3,
      symbolWidth: 12,
      verticalAlign: "bottom",
    },
  });

  console.log(chartOptions);

  useEffect(() => {
    setChartOptions((prevOptions) => ({
      ...prevOptions,
      title: {
        ...prevOptions.title,
        text: title,
      },
      subtitle: {
        ...prevOptions.subtitle,
        text: subtitle,
      },
      series: seriesArray,
    }));
  }, [seriesArray]);

  return (
    <div className="chart">
      <HighchartsReact
        highcharts={Highcharts}
        options={chartOptions}
        containerProps={{
          style: {
            height: "100%",
            width: "100%",
          },
        }}
      />
    </div>
  );
};

export default Chart;
